import { cva } from '@/styled-system/css';

export const textButtonLabelRecipe = cva({
  base: {
    textDecoration: { base: 'TextButton.default' },
  },
  variants: {
    tone: {
      brand: {
        color: { base: 'TextButton.brand.label.default' },
      },
      neutral: {
        color: { base: 'TextButton.neutral.label.default' },
      },
      subtle: {
        color: { base: 'TextButton.subtle.label.default' },
      },
    },
    onImpact: {
      true: {
        color: { base: 'TextButton.onImpact.neutral.label.default' },
        textDecoration: { base: 'TextButton.onImpact.default' },
      },
      false: {},
    },
    disabled: {
      true: {},
      false: {},
    },
    textStyle: {
      'body': {},
      'body-bold': {},
      'body-sm': {},
      'body-sm-bold': {},
    },
  },

  compoundVariants: [
    {
      tone: 'brand',
      disabled: false,
      css: {
        color: {
          _groupHover: 'TextButton.brand.label.hover',
          _groupActive: 'TextButton.brand.label.pressed',
        },
      },
    },
    {
      tone: 'neutral',
      disabled: false,
      css: {
        color: {
          _groupHover: 'TextButton.neutral.label.hover',
          _groupActive: 'TextButton.neutral.label.pressed',
        },
      },
    },
    {
      tone: 'subtle',
      disabled: false,
      css: {
        color: {
          _groupHover: 'TextButton.subtle.label.hover',
          _groupActive: 'TextButton.subtle.label.pressed',
        },
      },
    },
    {
      onImpact: true,
      disabled: false,
      css: {
        color: {
          _groupHover: 'TextButton.onImpact.neutral.label.hover',
          _groupActive: 'TextButton.onImpact.neutral.label.pressed',
        },

        textDecoration: { _groupHover: 'TextButton.onImpact.hover' },
      },
    },
    {
      onImpact: false,
      disabled: false,
      css: {
        textDecoration: {
          _groupHover: 'TextButton.hover',
        },
      },
    },
  ],
});
